export default __webpack_public_path__ + "static/media/295.60b2186a.gif";